import React, { useContext } from 'react'
import { MenuContext } from '@context/CatalogMenuState'
import * as S from './Header.styled'
import InfoBlock from './InfoBlock/InfoBlock'
import CatalogSelectorBlock from './CatalogSelectorBlock/CatalogSelectorBlock'
import CatalogNavigator from './CatalogNavigator/CatalogNavigator'
import SelectorStock from '../SelectorStock/SelectorStock'
import {
    useIsAddressSelector,
    useIsCitySelector,
    useIsStockSelector,
    useToggleStockSelector
} from 'src/features/shipment-selector/hooks'
import { CitySelectorDesktop } from 'src/features/shipment-selector/ui/desktop/city-selector-desktop'
import ModalAddressSelect from '@components/Basket/BasketShipment/ModalAddressSelect/ModalAddressSelect'

const Header = () => {
    const { isCatalogMenuOpen, toggleMenuMode } = useContext(MenuContext)
    const toggleStockSelector = useToggleStockSelector()
    const isStockSelector = useIsStockSelector()
    const isAddressSelector = useIsAddressSelector()
    const isCitySelector = useIsCitySelector()
    return (
        <S.Container>
            <InfoBlock />
            <CatalogSelectorBlock />
            {isCatalogMenuOpen && <CatalogNavigator toggleShowedMenu={toggleMenuMode} />}
            {isCitySelector && <CitySelectorDesktop />}
            {isStockSelector && <SelectorStock closeHandler={toggleStockSelector} />}
            {isAddressSelector && <ModalAddressSelect />}
        </S.Container>
    )
}

export default Header
